/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { optional as codecOptional, string as codecString } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseReleaseInfo } from './BaseReleaseInfo';
const ReleaseInfoParser = /* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['date', /* #__PURE__ */ codecOptional(parsers.moment)],
    ['version', /* #__PURE__ */ codecOptional(codecString)],
    ['message', /* #__PURE__ */ codecOptional(codecString)],
    ['uiPreference', /* #__PURE__ */ codecOptional(codecString), 'ui_preference'],
]), BaseReleaseInfo);
export class ReleaseInfo extends BaseReleaseInfo {
    static decode(input) {
        return ReleaseInfoParser.decode(input).map(res => new ReleaseInfo(res));
    }
    static unsafeDecode(input) {
        return ReleaseInfo.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ReleaseInfoParser.encode(data);
    }
    static schema() {
        return ReleaseInfoParser.schema();
    }
}
